import React from 'react';
import propTypes from 'prop-types';

export const ClaimIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      viewBox="0 0 24 24"
      version="1.1"
      fill={color}
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity={1}
          d="M 20.25 6 L 19 6 L 19 8 L 20 8 L 20 16 L 17 16 C 16.445312 16 16 16.445312 16 17 L 16 18.585938 L 13.707031 16.292969 C 13.519531 16.105469 13.265625 16 13 16 L 10.828125 16 L 8.828125 18 L 12.585938 18 L 16.292969 21.707031 C 16.578125 21.992188 17.007812 22.078125 17.382812 21.921875 C 17.757812 21.769531 18 21.40625 18 21 L 18 18 L 20.25 18 C 21.21875 18 22 17.21875 22 16.25 L 22 7.75 C 22 6.78125 21.21875 6 20.25 6 Z M 20.25 6 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity={1}
          d="M 7 18 C 6.445312 18 6 17.554688 6 17 L 6 14 L 3.75 14 C 2.78125 14 2 13.21875 2 12.25 L 2 3.75 C 2 2.78125 2.78125 2 3.75 2 L 16.25 2 C 17.21875 2 18 2.78125 18 3.75 L 18 12.25 C 18 12.714844 17.8125 13.15625 17.484375 13.488281 C 17.15625 13.816406 16.710938 14 16.25 14 L 11.414062 14 L 7.707031 17.707031 C 7.519531 17.894531 7.265625 18 7 18 Z M 4 12 L 7 12 C 7.554688 12 8 12.445312 8 13 L 8 14.585938 L 10.292969 12.292969 C 10.480469 12.105469 10.734375 12 11 12 L 16 12 L 16 4 L 4 4 Z M 4 12 "
        />
      </g>
    </svg>
  );
};
ClaimIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
ClaimIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
